// extracted by mini-css-extract-plugin
export var blue = "_49-f";
export var brand = "_49-b";
export var darkGrey = "_49-e";
export var disabled = "_49-4";
export var disabledSubtle = "_49-5";
export var error = "_49-6";
export var green = "_49-g";
export var grey = "_49-d";
export var icon = "_49-0";
export var inherit = "_49-a";
export var lightGrey = "_49-c";
export var orange = "_49-i";
export var pink = "_49-k";
export var primary = "_49-1";
export var purple = "_49-l";
export var red = "_49-j";
export var secondary = "_49-2";
export var success = "_49-9";
export var tertiary = "_49-3";
export var warning = "_49-7";
export var warningSecondary = "_49-8";
export var white = "_49-m";
export var yellow = "_49-h";